import React from "react"
import PropTypes from "prop-types"
import { VehicleServiceHistory, Heading, WysiwygContent } from "components"
import { ColumnGroup, Column } from "containers"
import { gtmMyMazda2ActionTypes } from "store/gtm-events"

const MyMazdaVehicleServiceHistoryBlock = props => (
  <ColumnGroup verticalPadding backgroundColor={props.backgroundColor || "#fff"}>
    <Column textAlignMobile="left" textAlign="left">
      {props.heading && (
        <Heading
          size="medium"
          value={props.heading}
          customHeadingStyle={{ marginBottom: "0.5em", textAlign: "center" }} />
      )}
      {props.blurb && (
        <p style={{ fontSize: "14px", fontWeight: "200", textAlign: "center", lineHeight: "20px" }}>{props.blurb}</p>
      )}
      <VehicleServiceHistory
        gtmOnHistoryButtonClick={createGtmAction.historyButtonClick}
        {...props} />
    </Column>
  </ColumnGroup>
)

MyMazdaVehicleServiceHistoryBlock.propTypes = {
  backgroundColor: PropTypes.string,
  heading: PropTypes.string,
  blurb: PropTypes.string
}

const createGtmAction = {
  historyButtonClick: ({ buttonText }) => ({
    gtmID: gtmMyMazda2ActionTypes.SERVICE_HISTORY_CLICK,
    gtmPayload: { buttonText }
  })
}

export default MyMazdaVehicleServiceHistoryBlock



// WEBPACK FOOTER //
// ./src/blocks/mymazda/service/history.jsx